
<template>

  <button
    :class="classes"
    :disabled="disabled"
  >
    <template v-if="$slots.icon">
      <slot class="icon" name="icon" />
      {{ text }}
    </template>

    <slot
      class="icon"
      v-else-if="$slots.default"
    />

    <template v-else>
      {{ text }}
    </template>
  </button>
</template>

<script>
export default {
  name: 'VButton',
  props: {
    text: [String, Number],
    variant: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary', 'tertiary'].includes(value);
      },
    },
    size: {
      type: String,
      default: 'lg',
      validator(value) {
        return ['lg', 'sm'].includes(value);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    classes() {
      const size = `size--${this.size}`;
      const variant = `button--${this.variant}`;

      return {
        'button-component': true,
        [variant]: true,
        [size]: true,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.button-component {
  display: flex;
  position: relative;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 2px 8px;
  line-height: 150%;
  font-weight: 600;
  text-align: center;
  border: 1px solid transparent;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.3s ease;

  svg {
    margin-right: 8px;
  }
}

.button {
  &--primary {
    background-color: var(--color-button-primary);
    color: #fff;

    &:hover {
      background-color: var(--color-button-primary-darken);
    }

    &:active, &:focus {
      border: 2px solid transparent;
      background-color:  var(--color-button-primary-darken);
      box-shadow: inset 0 0 0 2px var(--color-button-primary-lighten);
    }
  }

  &--secondary {
    background-color: transparent;
    border: 1px solid var(--color-button-primary);
    color: var(--color-button-primary);

    &:hover {
      background-color: var(--color-terciary-lighten-4);
    }

    &:focus {
      background-color: var(--color-terciary-lighten-4);
      border: 2px solid var(--color-button-primary);
      box-shadow: inset 0 0 0 2px #fff;
    }
  }

  &--tertiary {
    background-color: transparent;
    border: 2px solid transparent;
    color: var(--color-button-primary-darken);

    &:focus {
      background-color: var(--color-terciary-lighten-4);
      border: 2px solid var(--color-button-primary);
      box-shadow: inset 0 0 0 2px #fff;
      transition: all 0.3s ease 0s;
    }

    &:hover {
      background-color: var(--color-terciary-lighten-4);
    }
  }
}

.size--sm {
  min-width: 124px;
  height: 38px;
  width: 100%;
  font-size: var(--font-size-2);
}

.size--lg {
  min-width: 264px;
  height: 48px;
  width: 100%;
  font-size: var(--font-size-3);
}

.button-component:disabled {
  background-color: var(--color-grey-5);
  color: var(--color-grey-1);
  cursor: not-allowed;
  user-select: none;
}

</style>
